import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { formatPhoneNumber, isPlural } from '../util/Helper';
import { Button } from 'react-bootstrap';

const ListItem = (props) => {
  const ImageSrc = () => {
    if (props.listing.photos && props.listing.photos.length) {
      return (<img className='object-fit-cover' alt={props.listing.photos[0].title} src={process.env.REACT_APP_IMAGE_BASE + props.listing.photos[0].imageUrl} />);
    } else {
      return (<img className='object-fit-cover' src='no-picture-available-icon-1.jpg' alt={props.title ? 'Image of property at ' + props.title : 'No picture available'} />);
    }
  }

  return (
    <div className='panel panel-default listing-card' onMouseOver={console.log(props)}>
      <div class="panel-heading"><a href="#" onClick={(evt) => {
            evt.preventDefault();
            props.itemSelect(props.listing);
          }}>{(props.listing.locationGroupTitle) ? props.listing.locationGroupTitle : props.listing.listingAddress}</a></div>
      {/*<div className='img-container-outer'>
        <div className='img-container'>
          <ImageSrc props={props} />
        </div>
  </div>*/}{console.log('locationGrouptitle', props.listing.locationGroupTitle)}
      <div className="panel-body hidden-xs hidden-sm hidden-md">
      <p class="lead">{props.title} </p>
      
       {/* <p>
          <button
            className='detailsFromTitle'
            onClick={(evt) => {
              evt.preventDefault();
              props.itemSelect(props.listing);
            }}
            aria-label="{props.title}"
          >
            {props.title}

          </button>
        </p>*/}
        <div class="well">
        <p className='meta'>
          {props.listing.unitTypeTitle} <br /><b className='cardInfoBold'>${props.listing.rent}</b><br />
          {props.listing.leaseTypeTitle} lease<br />{props.listing.bedroomCount}{' '}
          bedroom{isPlural(props.listing.bedroomCount)}<br /><b className='cardInfoBold'><FontAwesomeIcon icon={faPhone} /> {formatPhoneNumber(props.listing.contactPhone)}</b>
        </p>
        </div>
        {<p>{props.description}</p>}
      </div>
      <div className="panel-footer hidden-xs hidden-sm hidden-md">
        <div className="text-right">
          <Button onClick={(evt) => {
            evt.preventDefault();
            props.itemSelect(props.listing);
          }} className="btn btn-sm btn-primary" >Details</Button></div>
      </div>

    </div>
  );
};

export default ListItem;
